import { Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const { Title, Paragraph } = Typography;

const BerninaHero = () => {
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	const { t } = useTranslation();

	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const titleSize =
		windowWidth < 768 ? "2.5rem" : windowWidth < 1024 ? "3.5rem" : "4.5rem";
	const paragraphSize = windowWidth < 768 ? "1.2rem" : "1.5rem";

	return (
		<div
			className="hero-container"
			style={{
				marginTop: "-100px",
				padding: windowWidth < 768 ? "32px 24px" : "64px 48px",
				textAlign: "center",
				color: "white",
				position: "relative",
				height: "60vh",
				minHeight: "400px",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				paddingTop: "68px",
				overflow: "hidden",
			}}
		>
			<div
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundImage:
						'linear-gradient(to bottom, #F5F5F5 0%, transparent 15%), linear-gradient(to top, #F5F5F5 0%, transparent 15%), linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url("https://www.happy.rentals/admin/uploads/The-Bernina-Express-passing-in-Filisur-Switzerland--98978.jpg")',
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundAttachment: windowWidth < 768 ? "scroll" : "fixed",
					backgroundRepeat: "no-repeat",
					zIndex: 0,
				}}
			/>
			<div
				style={{
					position: "relative",
					zIndex: 1,
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					width: "100%",
					maxWidth: "100vw",
				}}
			>
				<Title
					style={{
						color: "white",
						marginBottom: windowWidth < 768 ? "16px" : "24px",
						fontSize: titleSize,
						textShadow: "2px 2px 10px rgba(0, 0, 0, 0.8)",
						textAlign: "center",
					}}
				>
					Bernina Red Train & Bernina Express
				</Title>
				<Paragraph
					style={{
						fontSize: paragraphSize,
						color: "rgba(255,255,255,0.95)",
						maxWidth: "800px",
						margin: "0 auto",
						textShadow: "1px 1px 5px rgba(0, 0, 0, 0.8)",
						textAlign: "center",
					}}
				>
					Experience one of the most spectacular train journeys in the world,
					crossing the Swiss Alps from Tirano to St. Moritz.
				</Paragraph>
			</div>
		</div>
	);
};

export default BerninaHero;
